export const centsToEuros = (cents: number) => cents / 100
export const euroToCents = (euros: number) => euros * 100
